import React, {Component} from 'react'
import {Redirect, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import fetch from 'node-fetch'

import {FaStar} from 'react-icons/fa'
import Header from '../Header/Header'
import './JobItemDetailsRoute.css'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class JobItemDetailsRoute extends Component {
  state = {
    jobData: null,
    similarJobs: [],
    apiStatus: apiStatusConstants.initial,
    errorMessage: '',
  }

  componentDidMount() {
    this.fetchJobDetails()
  }

  fetchJobDetails = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})

    const jwtToken = Cookies.get('jwt_token')
    if (!jwtToken) return

    const {match} = this.props
    const {id} = match.params
    const jobDetailsApiUrl = `https://apis.ccbp.in/jobs/${id}`

    try {
      const response = await fetch(jobDetailsApiUrl, {
        method: 'GET',
        headers: {Authorization: `Bearer ${jwtToken}`},
      })

      if (!response.ok) {
        throw new Error('Failed to fetch job details')
      }

      const data = await response.json()

      if (data.job_details) {
        const formattedJobDetails = {
          companyLogoUrl: data.job_details.company_logo_url,
          companyWebsiteUrl: data.job_details.company_website_url,
          employmentType: data.job_details.employment_type,
          jobDescription: data.job_details.job_description,
          location: data.job_details.location,
          packagePerAnnum: data.job_details.package_per_annum,
          rating: data.job_details.rating,
          title: data.job_details.title,
          skills: data.job_details.skills.map(skill => ({
            name: skill.name,
            imageUrl: skill.image_url,
          })),
        }

        const formattedSimilarJobs = data.similar_jobs.map(job => ({
          id: job.id,
          companyLogoUrl: job.company_logo_url,
          employmentType: job.employment_type,
          jobDescription: job.job_description,
          location: job.location,
          rating: job.rating,
          title: job.title,
        }))

        this.setState({
          jobData: formattedJobDetails,
          similarJobs: formattedSimilarJobs,
          apiStatus: apiStatusConstants.success,
        })
      } else {
        this.setState({apiStatus: apiStatusConstants.failure})
      }
    } catch (error) {
      console.error('Error fetching job details:', error)
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  renderJobDetails = () => {
    const {jobData, similarJobs} = this.state
    if (!jobData) return null

    return (
      <div className="job-details-container">
        {/* Job Header */}
        <section className="job-header">
          <div className="company-details">
            <img src={jobData.companyLogoUrl} alt="job details company logo" />
            <div>
              <p>
                <FaStar color="gold" /> {jobData.rating}
              </p>

              <a href={jobData.companyWebsiteUrl}>Visit</a>
            </div>
          </div>
          <div>
            <h1>{jobData.title}</h1>
            <p>
              {jobData.location} | {jobData.employmentType}
            </p>
            <p>{jobData.packagePerAnnum}</p>
          </div>
        </section>

        {/* Job Description */}
        <section>
          <h1>Description</h1>
          <p>{jobData.job_description}</p>
        </section>

        {/* Skills Section */}
        {jobData.skills?.length > 0 && (
          <section>
            <h2>Skills</h2>
            <ul className="skills-list">
              {jobData.skills.map(skill => (
                <li key={skill.name}>
                  <img src={skill.imageUrl} alt={skill.name} />
                  <p>{skill.name}</p>
                </li>
              ))}
            </ul>
          </section>
        )}

        {/* Life at Company */}
        {jobData.life_at_company && (
          <section>
            <h2>Life at Company</h2>
            <p>{jobData.lifeAtCompany.description}</p>
            <img src={jobData.lifeAtCompany.imageUrl} alt="life at company" />
          </section>
        )}

        {/* Similar Jobs Section */}
        {similarJobs.length > 0 && (
          <section>
            <h2>Similar Jobs</h2>
            <ul className="similar-jobs-list">
              {similarJobs.map(similarJob => (
                <article key={similarJob.id} className="similar-job-card">
                  <img
                    src={similarJob.companyLogoUrl}
                    alt="similar job company logo"
                  />
                  <h3>{similarJob.title}</h3>
                  <p>
                    <FaStar color="gold" /> {similarJob.rating}
                  </p>

                  <h1>Description</h1>
                  <p>{similarJob.jobDescription}</p>
                  <p>
                    {similarJob.location} | {similarJob.employmentType}
                  </p>
                </article>
              ))}
            </ul>
          </section>
        )}
      </div>
    )
  }

  render() {
    const {apiStatus, errorMessage} = this.state
    const jwtToken = Cookies.get('jwt_token')

    if (!jwtToken) {
      return <Redirect to="/login" />
    }

    return (
      <>
        <Header />
        {apiStatus === apiStatusConstants.inProgress && (
          <div className="loader-container" data-testid="loader">
            <Loader type="ThreeDots" color="#ffffff" height={50} width={50} />
          </div>
        )}
        {apiStatus === apiStatusConstants.success && this.renderJobDetails()}
        {apiStatus === apiStatusConstants.failure && (
          <div className="failure-view">
            <img
              src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
              alt="failure view"
            />
            <h1>Oops! Something Went Wrong</h1>
            <p>We cannot seem to find the page you are looking for</p>
            <button
              type="button"
              onClick={this.fetchJobDetails}
              data-testid="retryButton"
            >
              Retry
            </button>
          </div>
        )}
      </>
    )
  }
}

export default withRouter(JobItemDetailsRoute)
